<template>
  <div class="container-pay">
    <img
      src="https://api.belladasemana.com.br/storage/br/assine-cc-2.png"
      alt="VISA | MasterCard | Amex | Diners | ELO | HIPERCARD"
      width="304"
      height="26"
    />
    <div class="list-radio">
      <input
        v-for="index in 6"
        :key="index"
        class="form-check-input"
        type="radio"
        name="flexRadioDefault"
        :id="'flexRadiocard' + index"
      />
    </div>
    <span class="legend mt-3" v-html="translate.legendFormCreditCard"></span>

    <div class="row my-5">
      <div class="col-12">
        <div class="form-group">
          <input
            ref="name"
            type="text"
            class="form-control"
            name="name"
            :placeholder="translate.nameHolderCreditCards"
            v-model="formCC.name"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            name="cpf"
            v-if="locale == 'pt-br'"
            :placeholder="translate.cpfCreditCards"
            v-model="formCC.cpf"
            v-maska
            data-maska="###.###.###-##"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            name="text"
            :placeholder="translate.numberCreditCards"
            v-model="formCC.number"
            v-maska
            :data-maska="['#### #### #### ####', '#### ###### #####']"
          />
        </div>
      </div>
      <div class="col-3 label mb-3">
        <span>{{ translate.validCreditCards }}</span>
      </div>
      <div class="col-lg-4 col-4 mb-3">
        <div class="form-group">
          <select name="mes" v-model="formCC.mes" class="select-box form-control">
            <option v-for="item in 12" :value="formatMes(item)" :key="item">
              {{ formatMes(item) }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-lg-4 col-4 mb-3">
        <div class="form-group">
          <select name="mes" v-model="formCC.ano" class="select-box form-control">
            <option v-for="item in 15" :value="formatAno(item)" :key="item">
              {{ formatAno(item) }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            name="cvv"
            :placeholder="translate.cvvCreditCards"
            v-model="formCC.cvv"
          />
        </div>
      </div>
      <div class="col-3 label mb-3" v-if="locale === 'pt-br'">
        <span>{{ translate.parcelas }}</span>
      </div>
      <div class="col-lg-4 col-4 mb-3" v-if="locale === 'pt-br'">
        <div class="form-group">
          <select name="parcelas" v-model="formCC.parcelas" class="select-box form-control">
            <option v-for="item in 3" :value="item" :key="item">{{ item }}x</option>
          </select>
        </div>
      </div>
      <div class="text-center mt-3" v-if="loading">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else class="col-12 mt-3 d-flex justify-content-center">
        <button class="d-w-btn" type="submit" @click="salvarForm(1)">Concluir Compra</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { mapState, mapActions } from 'pinia'
  import { defineComponent } from 'vue'
  import { localeStore } from 'stores/locale'
  import { userStore } from 'stores/user'
  import { jwtStore } from 'stores/jwt'
  import tradutor from 'tradutors/assine'
  import Iugu from '@/util/iugu'
  import api from '../../api'
  import { event } from 'vue-gtag'
  import router from '../../router'
  import { planStore } from '../../stores/plans'
  import { planCreditStore } from '../../stores/planscredits'

  export default defineComponent({
    name: 'FormPaymentCreditCard',
    computed: {
      ...mapState(localeStore, ['locale']),
      ...mapState(userStore, ['isLoggedIn']),
      ...mapState(planStore, ['coupon']),
      ...mapState(planCreditStore, ['plansCredits']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return tradutor.portugues
        } else {
          return tradutor.ingles
        }
      }
    },
    emits: ['showModalMessages'],
    mounted() {
      let brand_cc = document.getElementsByName('flexRadioDefault')
      if (brand_cc.length > 0) brand_cc[0].checked = true

      let plans = document.getElementsByName('flexRadioPlansCredits')

      plans.forEach((e, index) => {
        if (e.checked) {
          this.eventGTM(index)
        }
      })
    },
    data() {
      return {
        formCC: {
          name: '',
          cpf: '',
          number: '',
          cvv: '',
          mes: this.formatMes(1),
          ano: this.formatAno(1),
          parcelas: 1
        },
        indexValue: '0,00',
        brands: [
          'visa',
          'mastercard',
          'amex',
          'diners',
          'elo',
          'hipercard',
          'aura',
          'jcb',
          'credz',
          'discover',
          'hiper'
        ],
        form: null,
        loading: false
      }
    },
    methods: {
      ...mapActions(userStore, ['setUser']),
      ...mapActions(jwtStore, ['setJwt']),
      formatMes(value) {
        return value > 9 ? value : `0${value}`
      },
      formatAno(value) {
        let year = new Date().getFullYear() - 1
        return year + value
      },
      checkForm(formCheck: any) {
        if (!this.isLoggedIn) {
          if (!formCheck.firstName) {
            this.error(this.locale == 'pt-br' ? 'Nome é obrigatório!' : 'Name is riquered!')
            return false
          }
          if (!formCheck.lastName) {
            this.error(
              this.locale == 'pt-br' ? 'Sobrenome é obrigatório!' : 'Lastname is riquered!'
            )
            return false
          }
          if (!formCheck.email) {
            this.error(this.locale == 'pt-br' ? 'Email é obrigatório!' : 'Email is riquered!')
            return false
          }
          if (!formCheck.emailAgain) {
            this.error(
              this.locale == 'pt-br'
                ? 'Confirmação de email é obrigatório!'
                : 'Email confirmation is riquered!'
            )
            return false
          }
          if (!formCheck.country) {
            this.error(this.locale == 'pt-br' ? 'País é obrigatório!' : 'Country is riquered!')
            return false
          }
          if (!formCheck.password) {
            this.error(this.locale == 'pt-br' ? 'Senha é obrigatório!' : 'Password is riquered!')
            return false
          }
          if (!formCheck.passwordAgain) {
            this.error(
              this.locale == 'pt-br'
                ? 'Confirmação de senha é obrigatório!'
                : 'Password confirmation is riquered!'
            )
            return false
          }
          if (!formCheck.acept) {
            this.error(
              this.locale == 'pt-br' ? 'Termos e condições é obrigatório!' : 'Terms is riquered!'
            )
            return false
          }
        }

        if (!formCheck.card_name) {
          this.error(
            this.locale == 'pt-br' ? 'Nome de titular é obrigatório!' : 'Holder Name is riquered!'
          )
          return false
        }
        if (!formCheck.card_number) {
          this.error(
            this.locale == 'pt-br'
              ? 'Numero do cartão é obrigatório!'
              : 'Number Credit Card is riquered!'
          )
          return false
        }
        if (!formCheck.card_month) {
          this.error(
            this.locale == 'pt-br'
              ? 'mês de validade do cartão é obrigatório!'
              : 'Mounth Credit Card is riquered!'
          )
          return false
        }
        if (!formCheck.card_year) {
          this.error(
            this.locale == 'pt-br'
              ? 'ano de validade do cartão é obrigatório!'
              : 'Year Credit Card is riquered!'
          )
          return false
        }
        if (!formCheck.card_sec_number) {
          this.error(
            this.locale == 'pt-br'
              ? 'Senha do cartão é obrigatório!'
              : 'Cvv Credit Card is riquered!'
          )
          return false
        }
        if (!formCheck.card_cpf && this.locale == 'pt-br') {
          this.error('Cpf é obrigatório!')
          return false
        }

        return true
      },
      error(value) {
        this.$emit('showModalMessages', {
          message: { show: true, title: 'Erro', textButton: 'Fechar', textBoby: value }
        })
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'erro',
          erro: {
            tipo: value
          }
        })
      },
      success(value) {
        this.$emit('showModalMessages', {
          message: { show: true, title: 'Sucesso', textButton: 'Fechar', textBoby: value }
        })
      },
      redirect(name) {
        router.push({
          name,
          params: {
            locale: this.locale
          }
        })
      },
      eventGTM(index: number) {
        let value = '0,00'
        if (this.plansCredits[index])
          if (this.plansCredits[index].discount > 0 && this.plansCredits[index].discount_value)
            value = this.plansCredits[index].discount_value
          else value = this.plansCredits[index].value
        this.indexValue = value
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'add_payment_info',
          payment: {
            acionador: this.$route.query.acionador ?? 'link direto',
            tipo: 'Crédito',
            valor: value,
            currency: this.locale === 'pt-br' ? 'BRL' : 'USD',
            forma: 'Cartão de Crédito'
          }
        })
      },
      eventGTMPurchase(transaction_id) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'purchase',
          purchase: {
            acionador: this.$route.query.acionador ?? 'link direto',
            tipo: 'Crédito',
            valor: this.indexValue,
            transaction_id,
            forma: 'Cartão de Crédito'
          }
        })
      },
      salvarForm(method: number) {
        this.loading = true
        event('checkout2', { method: 'Credit Card' })
        if (!this.isLoggedIn)
          this.form = {
            firstName: document.getElementById('firstName').value,
            lastName: document.getElementById('lastName').value,
            email: document.getElementById('email').value,
            emailAgain: document.getElementById('emailAgain').value,
            anotherEmail: document.getElementById('anotherEmail').value,
            country: document.getElementById('country').value,
            password: document.getElementById('password').value,
            passwordAgain: document.getElementById('passwordAgain').value,
            acept: document.getElementById('acept').checked,
            card_name: this.formCC.name,
            card_number: this.formCC.number,
            card_month: this.formCC.mes,
            card_year: this.formCC.ano,
            card_sec_number: this.formCC.cvv,
            card_cpf: this.formCC.cpf,
            parcelas: this.formCC.parcelas,
            locale: this.locale,
            method
          }
        else
          this.form = {
            card_name: this.formCC.name,
            card_number: this.formCC.number,
            card_month: this.formCC.mes,
            card_year: this.formCC.ano,
            card_sec_number: this.formCC.cvv,
            card_cpf: this.formCC.cpf,
            locale: this.locale,
            parcelas: this.formCC.parcelas,
            method
          }

        let plans = document.getElementsByName('flexRadioPlansCredits')
        let typecc = document.getElementsByName('flexRadioDefault')

        plans.forEach((e) => {
          if (e.checked) {
            this.form.plan = Number(e.id.replace('flexRadioPlansCredits', ''))
          }
        })

        typecc.forEach((e) => {
          if (e.checked) {
            let index = Number(e.id.replace('flexRadiocard', ''))
            this.form.card_type = this.brands[index - 1]
          }
        })

        if (this.checkForm(this.form)) {
          /* ----- IUGU JS CONFIG TOKEN -----*/
          const iugu = Iugu()
          // iugu.setTestMode(true);
          iugu.setAccountID('E1CD8DA37390444981B2F9D62D1DCC58')

          let names = this.form.card_name.split(' ')

          if (names.length < 2) {
            this.error('Nome do titular inválido')
            this.loading = false
            return false
          }

          let cc = iugu.CreditCard(
            this.form.card_number,
            this.form.card_month,
            this.form.card_year,
            names[0],
            names[1],
            this.form.card_sec_number
          )

          iugu.createPaymentToken(cc, this.tokenResponseHandler)
          /* ----- FIM IUGU JS CONFIG TOKEN -----*/
        } else this.loading = false
      },
      tokenResponseHandler(data) {
        if (data.errors) {
          this.error(JSON.stringify(data.errors))
          this.loading = false
          return false
        }
        if (data.id) this.form.token = data.id

        this.form.coupon = this.$route.query.coupon ?? this.coupon ?? ''
        api
          .post('v1/subscribe/storeBuyCredits', this.form)
          .then(({ data }) => {
            if (data.login) {
              this.setUser(data.login.user)
              this.setJwt(data.login.jwt)
            }
            if (!data.process) {
              this.error(data.errors)
            }
            if (data.process) {
              this.eventGTMPurchase(data.orderId)
              this.success('Créditos adquiridos')
            }

            if (this.isLoggedIn && data.process) this.redirect('MyCreditsPage')
          })
          .catch(
            ({
              response: {
                data: { errors }
              }
            }) => this.error(errors)
          )
          .finally(() => {
            this.loading = false
          })
      }
    }
  })
</script>
<style scoped lang="css">
  .container-pay {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .list-radio {
    display: flex;
    flex-direction: row;
    margin-left: 24px;
  }

  .list-radio input {
    margin-inline-end: 35px;
  }

  .legend {
    font-size: 12px;
    width: 50%;
    color: gray;
    text-align: center;
  }

  .form-group input {
    padding: 15px 20px;
    border-radius: 30px;
    margin-bottom: 15px;
    background-color: #fff;
    font-size: small;
  }

  .form-control:focus {
    color: #000;
    background-color: #f8f8f8;
  }

  .select-box {
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: 50%;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" fill="rgb(178,0,0)"/></svg>');
  }

  .select-box {
    padding-left: 22px;
    font-size: small;
    cursor: pointer;
    text-align: center;
  }

  .label {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .d-w-btn {
    color: #fff;
    padding: 17px 30px;
    background: #52a734;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    min-width: 210px;
    align-items: center;
    font-family: 'Exo-2';
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
  }
</style>
